import { faBoxes } from '@fortawesome/free-solid-svg-icons';

/**
 * Product Module walkthrough.
 *
 * The "Product Module" lives at /dashboard/risk-analytics (legacy URL,
 * current label is "Product Management"). Unlike Cargo/Bunkers there is no
 * separate detail route - create/edit happens in modals on the same screen.
 *
 * The tour walks the page top-down: header actions, category tabs, subtype
 * chips, the Catalog/Stockpile view toggle, the live list area, and a quick
 * peek at the Stockpile summary tiles via the engine's ``clickBefore`` hook.
 */

const PRODUCT_ROUTE = '/dashboard/risk-analytics';

const productTour = {
    id: 'product',
    title: 'Product Module',
    description:
        'Walk through the product catalog: categories, subtypes, the Catalog vs Stockpile view, and how to add new products.',
    estimatedMinutes: 4,
    startRoute: PRODUCT_ROUTE,
    icon: faBoxes,
    group: 'module',
    steps: [
        {
            target: '[data-tour="product-page"]',
            title: 'Welcome to Product Management',
            content:
                'Every product IMT trades - coal, oil and gas, minerals, metals, cementitious, biomass and other - is catalogued here, along with live stockpile balances per variant.',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="product-header-actions"]',
            title: 'Add new products',
            content:
                'Two ways to create: Upload Contract extracts product details from a contract PDF and pre-fills the form for you. Add Product Item opens a blank form when you want to type it in by hand.',
            placement: 'bottom',
        },
        {
            target: '[data-tour="product-category-tabs"]',
            title: 'Product categories',
            content:
                'Top-level categories: Coal, Oil/Gas, Minerals, Metals, Cementitious, Biomass and Other. Switching a category re-filters the list below and unlocks that category\'s subtypes.',
            placement: 'bottom',
        },
        {
            target: '[data-tour="product-view-toggle"]',
            title: 'Catalog vs Stockpile',
            content:
                'Catalog is the master record of products and their variants (grade, supplier, source). Stockpile is the live inventory view: balances, inbound and outbound movements, recent history.',
            placement: 'bottom',
        },
        {
            target: '[data-tour="product-subtype-chips"]',
            title: 'Subtype chips',
            content:
                'Each category has its own subtypes. Coal splits into Steam Coal, Anthracite, Coke, PCI; Oil/Gas into Diesel, Gasoline, LNG, Jet Fuel - and so on. Click a chip to narrow the list to just that subtype.',
            placement: 'bottom',
            skipIfMissing: true,
        },
        {
            target: '[data-tour="product-content"]',
            title: 'Catalog list',
            content:
                'Each card is a product item. Click a card header to expand and see its variants - the same product from different suppliers, different sources, different grades. Variants are what get traded and stockpiled.',
            placement: 'top',
        },
        {
            target: '[data-tour="product-content"]',
            title: 'Stockpile view',
            content:
                'In Stockpile mode you see live balances per product/variant: opening, inbound, outbound, closing. The summary tiles at the top show totals for the selected category and time range.',
            placement: 'top',
            clickBefore: '[data-tour="product-view-stockpile"]',
        },
        {
            target: '[data-tour="product-page"]',
            title: 'You are good to go',
            content:
                'That is the Product Module. Catalog for the master data, Stockpile for the live inventory. Re-run this tour any time from Hamster Training.',
            placement: 'center',
            disableBeacon: true,
            isLast: true,
        },
    ],
};

export default productTour;
